import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./projectComponent.css";

const ProjectComponent = ({
  imageSrc,
  title,
  description,
  route,
  imgStyle,
}) => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    navigate(route);
  };

  const handleKeyDown = (event) => {
    // Trigger navigation on "Enter" or "Space" key
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault(); // Prevent default behavior for spacebar
      handleClick();
    }
  };

  return (
    <div
      className={`project-component ${isActive ? "active" : ""}`}
      onClick={handleClick}
      onKeyDown={handleKeyDown} // Add keyboard interaction
      onMouseEnter={() => setIsActive(true)}
      onMouseLeave={() => setIsActive(false)}
      tabIndex={0} // Make the component focusable
      role="button" // Indicate that this is an interactive element
      aria-label={`View project: ${title}`} // Provide a meaningful label for screen readers
    >
      <div className="project-info">
        <h1 className="project-title">{title}</h1>
        <p className="project-description">{description}</p>
      </div>
      <img
        src={imageSrc}
        alt={title}
        className="project-image"
        style={imgStyle} // Pass the imgStyle prop to the image
      />
    </div>
  );
};

export default ProjectComponent;
